import type { Responsive } from '../types/responsive';

import { toBreakpointEntries } from './toBreakpointEntries';

/**
 * Maps a responsive prop to CSS custom properties read by the `responsive-vars` Sass mixin:
 * `--{name}` for base and `--{name}-{breakpoint}` for the others.
 *
 * @example
 * getResponsiveVars('grid-columns', { base: 1, lg: '1fr 420px' }, toColumns)
 * // { '--grid-columns': 'repeat(1, minmax(0, 1fr))', '--grid-columns-lg': '1fr 420px' }
 */
export function getResponsiveVars<T extends string | number>(
    name: string,
    value: Responsive<T> | undefined,
    toCss: (item: T) => string,
): Record<`--${string}`, string> {
    if (value === undefined) {
        return {};
    }

    return Object.fromEntries(
        toBreakpointEntries(value).flatMap(([breakpoint, item]) => {
            if (item === undefined) {
                return [];
            }
            const key: `--${string}` = breakpoint === 'base' ? `--${name}` : `--${name}-${breakpoint}`;
            return [[key, toCss(item)]];
        }),
    );
}
